<div echarts [options]="options" style="height:100%;width:100%"></div>
